// extracted by mini-css-extract-plugin
export default {"animation":"best-for-you-module__animation--bNq","a":"best-for-you-module__a--Ixg"};